const bankSourceTranslations = {
  en: {
    title: "Official Source Registry",
    subtitle: "Manage verified origins for judicial, tax, banking and special-situation opportunities.",
    navigation: "Sources",
    back: "Back to opportunities",
    add: "Add source",
    edit: "Edit source",
    search: "Search sources…",
    allCategories: "All categories",
    allStatuses: "All statuses",
    total: "Registered sources",
    activeSources: "Active sources",
    officialSources: "Official sources",
    name: "Source name",
    category: "Category",
    officialUrl: "Official website",
    importMethod: "Import method",
    status: "Status",
    verification: "Verification",
    priority: "Priority",
    country: "Country",
    description: "Description",
    legalNotes: "Legal and usage notes",
    lastChecked: "Last checked",
    neverChecked: "Not yet checked",
    openOfficial: "Open official website",
    save: "Save source",
    saving: "Saving…",
    cancel: "Cancel",
    official: "Official",
    verified: "Verified",
    unverified: "Unverified",
    active: "Active",
    paused: "Paused",
    underReview: "Under review",
    disabled: "Disabled",
    manual: "Manual",
    noResults: "No registered sources match these filters.",
    notice: "Source records identify provenance only. Information must be verified before investor matching, publication or external distribution.",
    categories: {
      judicial_auction: "Judicial auction",
      court_proceeding: "Court proceeding",
      tax_sale: "Tax sale",
      bank: "Bank",
      fund: "Fund",
      servicer: "Servicer",
      insolvency_practitioner: "Insolvency practitioner",
      other: "Other",
    },
  },
  pt: {
    title: "Registo de Fontes Oficiais",
    subtitle: "Gerir origens verificadas de oportunidades judiciais, fiscais, bancárias e situações especiais.",
    navigation: "Fontes",
    back: "Voltar às oportunidades",
    add: "Adicionar fonte",
    edit: "Editar fonte",
    search: "Pesquisar fontes…",
    allCategories: "Todas as categorias",
    allStatuses: "Todos os estados",
    total: "Fontes registadas",
    activeSources: "Fontes ativas",
    officialSources: "Fontes oficiais",
    name: "Nome da fonte",
    category: "Categoria",
    officialUrl: "Website oficial",
    importMethod: "Método de importação",
    status: "Estado",
    verification: "Verificação",
    priority: "Prioridade",
    country: "País",
    description: "Descrição",
    legalNotes: "Notas legais e de utilização",
    lastChecked: "Última verificação",
    neverChecked: "Ainda não verificada",
    openOfficial: "Abrir website oficial",
    save: "Guardar fonte",
    saving: "A guardar…",
    cancel: "Cancelar",
    official: "Oficial",
    verified: "Verificada",
    unverified: "Não verificada",
    active: "Ativa",
    paused: "Pausada",
    underReview: "Em análise",
    disabled: "Desativada",
    manual: "Manual",
    noResults: "Nenhuma fonte registada corresponde aos filtros.",
    notice: "Os registos identificam apenas a proveniência. A informação deve ser verificada antes de qualquer correspondência com investidores, publicação ou divulgação externa.",
    categories: {
      judicial_auction: "Leilão judicial",
      court_proceeding: "Processo judicial",
      tax_sale: "Venda fiscal",
      bank: "Banco",
      fund: "Fundo",
      servicer: "Servicer",
      insolvency_practitioner: "Administrador de insolvência",
      other: "Outra",
    },
  },
  zh: {
    title: "官方来源登记册",
    subtitle: "管理司法、税务、银行及特殊机会的已核实信息来源。",
    navigation: "来源",
    back: "返回机会",
    add: "添加来源",
    edit: "编辑来源",
    search: "搜索来源…",
    allCategories: "所有类别",
    allStatuses: "所有状态",
    total: "已登记来源",
    activeSources: "活跃来源",
    officialSources: "官方来源",
    name: "来源名称",
    category: "类别",
    officialUrl: "官方网站",
    importMethod: "导入方式",
    status: "状态",
    verification: "核实状态",
    priority: "优先级",
    country: "国家",
    description: "说明",
    legalNotes: "法律及使用说明",
    lastChecked: "最后核查",
    neverChecked: "尚未核查",
    openOfficial: "打开官方网站",
    save: "保存来源",
    saving: "正在保存…",
    cancel: "取消",
    official: "官方",
    verified: "已核实",
    unverified: "未核实",
    active: "活跃",
    paused: "已暂停",
    underReview: "审核中",
    disabled: "已停用",
    manual: "手动",
    noResults: "没有符合筛选条件的登记来源。",
    notice: "来源记录仅用于识别信息出处。在投资者匹配、发布或对外传播前必须核实全部信息。",
    categories: {
      judicial_auction: "司法拍卖",
      court_proceeding: "法院程序",
      tax_sale: "税务出售",
      bank: "银行",
      fund: "基金",
      servicer: "资产服务机构",
      insolvency_practitioner: "破产管理人",
      other: "其他",
    },
  },
  fr: {
    title: "Registre des sources officielles",
    subtitle: "Gérer les sources vérifiées d’opportunités judiciaires, fiscales, bancaires et de situations spéciales.",
    navigation: "Sources",
    back: "Retour aux opportunités",
    add: "Ajouter une source",
    edit: "Modifier la source",
    search: "Rechercher des sources…",
    allCategories: "Toutes les catégories",
    allStatuses: "Tous les statuts",
    total: "Sources enregistrées",
    activeSources: "Sources actives",
    officialSources: "Sources officielles",
    name: "Nom de la source",
    category: "Catégorie",
    officialUrl: "Site officiel",
    importMethod: "Méthode d’importation",
    status: "Statut",
    verification: "Vérification",
    priority: "Priorité",
    country: "Pays",
    description: "Description",
    legalNotes: "Notes juridiques et d’utilisation",
    lastChecked: "Dernière vérification",
    neverChecked: "Pas encore vérifiée",
    openOfficial: "Ouvrir le site officiel",
    save: "Enregistrer la source",
    saving: "Enregistrement…",
    cancel: "Annuler",
    official: "Officielle",
    verified: "Vérifiée",
    unverified: "Non vérifiée",
    active: "Active",
    paused: "Suspendue",
    underReview: "En cours d’examen",
    disabled: "Désactivée",
    manual: "Manuelle",
    noResults: "Aucune source enregistrée ne correspond aux filtres.",
    notice: "Les fiches de source identifient uniquement la provenance. Toute information doit être vérifiée avant mise en relation, publication ou diffusion externe.",
    categories: {
      judicial_auction: "Vente judiciaire",
      court_proceeding: "Procédure judiciaire",
      tax_sale: "Vente fiscale",
      bank: "Banque",
      fund: "Fonds",
      servicer: "Gestionnaire d’actifs",
      insolvency_practitioner: "Administrateur d’insolvabilité",
      other: "Autre",
    },
  },
  es: {
    title: "Registro de fuentes oficiales",
    subtitle: "Gestionar fuentes verificadas de oportunidades judiciales, fiscales, bancarias y situaciones especiales.",
    navigation: "Fuentes",
    back: "Volver a oportunidades",
    add: "Añadir fuente",
    edit: "Editar fuente",
    search: "Buscar fuentes…",
    allCategories: "Todas las categorías",
    allStatuses: "Todos los estados",
    total: "Fuentes registradas",
    activeSources: "Fuentes activas",
    officialSources: "Fuentes oficiales",
    name: "Nombre de la fuente",
    category: "Categoría",
    officialUrl: "Sitio web oficial",
    importMethod: "Método de importación",
    status: "Estado",
    verification: "Verificación",
    priority: "Prioridad",
    country: "País",
    description: "Descripción",
    legalNotes: "Notas legales y de uso",
    lastChecked: "Última verificación",
    neverChecked: "Aún no verificada",
    openOfficial: "Abrir sitio oficial",
    save: "Guardar fuente",
    saving: "Guardando…",
    cancel: "Cancelar",
    official: "Oficial",
    verified: "Verificada",
    unverified: "No verificada",
    active: "Activa",
    paused: "Pausada",
    underReview: "En revisión",
    disabled: "Desactivada",
    manual: "Manual",
    noResults: "Ninguna fuente registrada coincide con los filtros.",
    notice: "Los registros identifican únicamente la procedencia. La información debe verificarse antes de relacionarla con inversores, publicarla o divulgarla.",
    categories: {
      judicial_auction: "Subasta judicial",
      court_proceeding: "Procedimiento judicial",
      tax_sale: "Venta fiscal",
      bank: "Banco",
      fund: "Fondo",
      servicer: "Gestor de activos",
      insolvency_practitioner: "Administrador concursal",
      other: "Otra",
    },
  },
  de: {
    title: "Register offizieller Quellen",
    subtitle: "Geprüfte Quellen für gerichtliche, steuerliche, bankeigene und besondere Chancen verwalten.",
    navigation: "Quellen",
    back: "Zurück zu den Chancen",
    add: "Quelle hinzufügen",
    edit: "Quelle bearbeiten",
    search: "Quellen durchsuchen…",
    allCategories: "Alle Kategorien",
    allStatuses: "Alle Status",
    total: "Registrierte Quellen",
    activeSources: "Aktive Quellen",
    officialSources: "Offizielle Quellen",
    name: "Quellenname",
    category: "Kategorie",
    officialUrl: "Offizielle Website",
    importMethod: "Importmethode",
    status: "Status",
    verification: "Prüfung",
    priority: "Priorität",
    country: "Land",
    description: "Beschreibung",
    legalNotes: "Rechts- und Nutzungshinweise",
    lastChecked: "Zuletzt geprüft",
    neverChecked: "Noch nicht geprüft",
    openOfficial: "Offizielle Website öffnen",
    save: "Quelle speichern",
    saving: "Speichern…",
    cancel: "Abbrechen",
    official: "Offiziell",
    verified: "Geprüft",
    unverified: "Ungeprüft",
    active: "Aktiv",
    paused: "Pausiert",
    underReview: "In Prüfung",
    disabled: "Deaktiviert",
    manual: "Manuell",
    noResults: "Keine registrierten Quellen entsprechen den Filtern.",
    notice: "Quelleneinträge dokumentieren ausschließlich die Herkunft. Angaben müssen vor Zuordnung, Veröffentlichung oder externer Weitergabe geprüft werden.",
    categories: {
      judicial_auction: "Gerichtliche Auktion",
      court_proceeding: "Gerichtsverfahren",
      tax_sale: "Steuerverkauf",
      bank: "Bank",
      fund: "Fonds",
      servicer: "Servicer",
      insolvency_practitioner: "Insolvenzverwalter",
      other: "Sonstige",
    },
  },
  it: {
    title: "Registro delle fonti ufficiali",
    subtitle: "Gestire fonti verificate per opportunità giudiziarie, fiscali, bancarie e situazioni speciali.",
    navigation: "Fonti",
    back: "Torna alle opportunità",
    add: "Aggiungi fonte",
    edit: "Modifica fonte",
    search: "Cerca fonti…",
    allCategories: "Tutte le categorie",
    allStatuses: "Tutti gli stati",
    total: "Fonti registrate",
    activeSources: "Fonti attive",
    officialSources: "Fonti ufficiali",
    name: "Nome della fonte",
    category: "Categoria",
    officialUrl: "Sito ufficiale",
    importMethod: "Metodo di importazione",
    status: "Stato",
    verification: "Verifica",
    priority: "Priorità",
    country: "Paese",
    description: "Descrizione",
    legalNotes: "Note legali e di utilizzo",
    lastChecked: "Ultima verifica",
    neverChecked: "Non ancora verificata",
    openOfficial: "Apri il sito ufficiale",
    save: "Salva fonte",
    saving: "Salvataggio…",
    cancel: "Annulla",
    official: "Ufficiale",
    verified: "Verificata",
    unverified: "Non verificata",
    active: "Attiva",
    paused: "In pausa",
    underReview: "In revisione",
    disabled: "Disattivata",
    manual: "Manuale",
    noResults: "Nessuna fonte registrata corrisponde ai filtri.",
    notice: "I registri identificano esclusivamente la provenienza. Le informazioni devono essere verificate prima dell’abbinamento, pubblicazione o diffusione esterna.",
    categories: {
      judicial_auction: "Asta giudiziaria",
      court_proceeding: "Procedimento giudiziario",
      tax_sale: "Vendita fiscale",
      bank: "Banca",
      fund: "Fondo",
      servicer: "Gestore di attivi",
      insolvency_practitioner: "Curatore fallimentare",
      other: "Altro",
    },
  },
  ru: {
    title: "Реестр официальных источников",
    subtitle: "Управление проверенными источниками судебных, налоговых, банковских и специальных возможностей.",
    navigation: "Источники",
    back: "Назад к возможностям",
    add: "Добавить источник",
    edit: "Изменить источник",
    search: "Поиск источников…",
    allCategories: "Все категории",
    allStatuses: "Все статусы",
    total: "Зарегистрированные источники",
    activeSources: "Активные источники",
    officialSources: "Официальные источники",
    name: "Название источника",
    category: "Категория",
    officialUrl: "Официальный сайт",
    importMethod: "Способ импорта",
    status: "Статус",
    verification: "Проверка",
    priority: "Приоритет",
    country: "Страна",
    description: "Описание",
    legalNotes: "Правовые условия использования",
    lastChecked: "Последняя проверка",
    neverChecked: "Ещё не проверено",
    openOfficial: "Открыть официальный сайт",
    save: "Сохранить источник",
    saving: "Сохранение…",
    cancel: "Отмена",
    official: "Официальный",
    verified: "Проверен",
    unverified: "Не проверен",
    active: "Активен",
    paused: "Приостановлен",
    underReview: "На проверке",
    disabled: "Отключён",
    manual: "Вручную",
    noResults: "Нет зарегистрированных источников, соответствующих фильтрам.",
    notice: "Записи указывают только происхождение данных. Информацию необходимо проверить до подбора инвесторов, публикации или внешнего распространения.",
    categories: {
      judicial_auction: "Судебный аукцион",
      court_proceeding: "Судебное производство",
      tax_sale: "Налоговая продажа",
      bank: "Банк",
      fund: "Фонд",
      servicer: "Сервисная компания",
      insolvency_practitioner: "Арбитражный управляющий",
      other: "Другое",
    },
  },
};

export default bankSourceTranslations;
